
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class WorkDeliveryStaticApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'work-delivery-statistic';
    }

    /**
    * 统计合同数据
    * @param year 年份 2024
    * @param month 月份 01
    */
    public getContractStatistic(year,month) {
        return this.send({year,month}, "getContractStatistic", Methods.GET);
    }

    
    /**
    * 统计开票和收款金额
    */
    public getInvoicePaymentStatistic(year,month, projectId) {
        return this.send({year,month,projectId}, "getInvoicePaymentStatistic", Methods.GET);
    }

    /**
    * 商务待办项目统计
    */
    public getBusinessToDoStatistic() {
        return this.send({}, "getBusinessToDoStatistic", Methods.GET);
    }

    /**
    * 实施待办项目统计
    */
    public getImplementationToDoStatistic() {
        return this.send({}, "getImplementationToDoStatistic", Methods.GET);
    }

    /**
    * 统计项目成果排行榜
    */
     public getProjectResultsRankings(pageNum: number = 1,pageSize: number = 10) {
        return this.send({pageNum,pageSize}, "getProjectResultsRankings", Methods.GET);
    }

    /**
    * 统计待办工作项
    */
     public getTodoWorkItems() {
        return this.send({}, "getTodoWorkItems", Methods.GET);
    }

    /**
    * 获取项目实施待办详情
    */
    public getProjectRelateInfoByProjectId(projectId: number) {
      return this.send({projectId}, "getProjectRelateInfoByProjectId", Methods.GET);
    }

    /**
    * 获取人员工作成果
    */
    public getPersonAllDelivery(userAccount: string, pageNum: number = 1, pageSize: number = 10) {
      return this.send({userAccount, pageNum, pageSize}, "getPersonAllDelivery", Methods.GET);
    }

    /**
    * 获取人员质量问题统计
    */
    public getPersonQualityProblem(userId: number, dateTime: string) {
        return this.send({userId, dateTime}, "getPersonQualityProblem", Methods.GET);
    }

    /**
    * 获取人员成果统计
    */
    public getPersonDeliveryTotal(userAccount: string, dateTime: string) {
        return this.send({userAccount, dateTime}, "getPersonDeliveryTotal", Methods.GET);
    }


}